// The approved homepage coil shares its geometry and material profiles with the
// full webbing studio. Product links address each product's own appearance UI.
const root=document.querySelector('[data-sw-collection]');
if(root){
 const coil=root.querySelector('[data-webbing]'),q=s=>coil.querySelector(s);
 const stocks=JSON.parse(root.querySelector('[data-coil-stocks]').textContent);
 function links(){
  const family=q('[data-coil-finish]').value,width=q('[data-coil-width]'),valid=stocks[family];
  for(const o of width.options)o.disabled=!valid[o.value];
  if(!valid[width.value])width.value=valid['1']?'1':Object.keys(valid)[0];
  const params=new URLSearchParams({stock:valid[width.value],feet:'30',team:q('[data-coil-colors]').value});
  for(const a of coil.querySelectorAll('[data-coil-link]'))a.href='/collections/strapworks-quick-ship-custom?'+params+'#'+a.dataset.coilLink;
  coil.dataset.appearance=JSON.stringify({finish:family,width:width.value,team:q('[data-coil-colors]').value});
 }
 coil.addEventListener('change',links);links();
 const observer=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){
  observer.unobserve(e.target);
  if(e.target===coil)import(root.dataset.coilModule).then(m=>m.mountCoil(coil)).catch(()=>{q('[data-coil-status]').textContent='Open the mapping studio to explore your roll.';});
  else import(root.dataset.modelModule).catch(()=>{root.querySelector('[data-laser-status]').textContent='Open LASERWEB to explore the interactive model.';});
 }},{rootMargin:'150px'});
 observer.observe(coil);const laser=root.querySelector('model-viewer');if(laser){observer.observe(laser);laser.addEventListener('load',()=>{root.querySelector('[data-laser-status]').hidden=true;laser.dataset.ready='true';});}
}
